import React from 'react';
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Switch,
  FormControlLabel,
  Paper,
  Table,
  TableBody,
  TableContainer
} from '@mui/material';
import FormRow from './FormRow';
import { getTimezoneLabel } from '../../utils/timezoneUtils';

const OtherDetailsTab = ({ formData, handleNestedChange, displayTimezone }) => {
  const tzLabel = displayTimezone ? getTimezoneLabel(displayTimezone) : '';
  return (
    <TableContainer 
      component={Paper} 
      variant="outlined" 
      sx={{ 
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}
    >
      <Box 
        sx={{ 
          p: 1.5, 
          bgcolor: 'primary.main', 
          color: 'white',
          borderRadius: '8px 8px 0 0'
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Other Details</Typography>
      </Box>
      <Table size="small" sx={{ '& .MuiTableCell-root': { borderColor: 'rgba(0, 0, 0, 0.08)' } }}>
        <TableBody>
          <FormRow label="Aircraft Not in use">
            <TextField
              fullWidth
              size="small"
              select
              value={formData.otherDetails.aircraftNotInUse}
              onChange={handleNestedChange('otherDetails', 'aircraftNotInUse')}
              sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
            >
              <MenuItem value="Yes">Yes</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </TextField>
          </FormRow>
          {formData.otherDetails.aircraftNotInUse === 'Yes' && (
            <FormRow label={tzLabel ? `Not In Use Date (${tzLabel})` : 'Not In Use Date'}>
              <TextField
                fullWidth
                size="small"
                type="date"
                value={formData.otherDetails.notInUseDate}
                onChange={handleNestedChange('otherDetails', 'notInUseDate')}
                InputLabelProps={{ shrink: true }}
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
          )}
          <FormRow label="Mark this aircraft as ReadOnly">
            <FormControlLabel
              control={
                <Switch
                  checked={formData.otherDetails.isReadOnly}
                  onChange={handleNestedChange('otherDetails', 'isReadOnly')}
                  color="primary"
                />
              }
              label={formData.otherDetails.isReadOnly ? 'Yes' : 'No'}
              sx={{ ml: 0 }}
            />
          </FormRow>
          {formData.otherDetails.isReadOnly && (
            <FormRow label={tzLabel ? `ReadOnly Date (${tzLabel})` : 'ReadOnly Date'}>
              <TextField
                fullWidth
                size="small"
                type="date"
                value={formData.otherDetails.readOnlyDate}
                onChange={handleNestedChange('otherDetails', 'readOnlyDate')}
                InputLabelProps={{ shrink: true }}
                sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' } }}
              />
            </FormRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OtherDetailsTab;

